export default "__VITE_ASSET__Dn5$9o1q__"